import { render } from "./status.vue?vue&type=template&id=6efa999f"
import script from "./status.js?vue&type=script&lang=js"
export * from "./status.js?vue&type=script&lang=js"

import "./status.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__